export default "__VITE_ASSET__93xIlzX1__"